import { FullScreenSearchContainer } from "@coworker/app/src/components/TestBuy/NewTestBuy/CustomArticleWidget";
import ScannerSearchComboComponent from "@coworker/apprestructured/src/scan-and-search/components/scanner-search-combo-component/ScannerSearchComboComponent";
import React from "react";

interface TestbuyItemSearchProps {
  setIsSearching: (isSearching: boolean) => void;
  handleScanResult: (productNo: string) => void;
}
export const TestbuyItemSearch = ({
  setIsSearching,
  handleScanResult,
}: TestbuyItemSearchProps) => {
  return (
    <FullScreenSearchContainer>
      <ScannerSearchComboComponent
        handleProductSearchResult={handleScanResult}
        handleCloseOfComponent={() => setIsSearching(false)}
      />
    </FullScreenSearchContainer>
  );
};
